import { GenericModelApi } from "./GenericModelApi";
import { ApiSchema, FetchResponse } from "./ApiClient";
import { ProviderRecibeFormData, ProviderRecibeRelatedAttributes } from "@/formTypes/ProviderRecibeFormDataType";
import { ProviderRecibeFormDataKeys } from "@/generated/ProviderRecibeFormDataKeys";

export type ProviderRecibeDataType = Partial<ApiSchema["ProviderRecibe"]["type"] & ProviderRecibeFormData>;

class Api extends GenericModelApi<"ProviderRecibe", ProviderRecibeDataType> {
    protected userSortKeyDateField = "created" as const
    /** Se crea desde el frontend, así que la etiqueta del creador se estampa aquí. */
    protected stampsCreatorUser = true


    async fetchAll(filters: any = {}, token?: string, limit: number = 20): Promise<FetchResponse<ProviderRecibeDataType>> {
        const selectionSet = [
            ...ProviderRecibeFormDataKeys.filter(k => !ProviderRecibeRelatedAttributes.includes(k)),
            "currency.*",
            "provider.*",
            // "provider", "bankAccount", "currency", "creditOperator", "providerInvoices"];
        ]

        return super.fetchAll(filters, token, limit, selectionSet);
    }

}
export const ProviderRecibeApi = new Api("ProviderRecibe", "numero_recibo", "DESC", "created")